import { Box, Chip, Typography } from '@mui/material'
import { useStyles } from './styles'

const StatusComponent = ({ color, msg, size, type, fit }: { fit?: boolean; color: string; msg: string; size?: 'xs' | 'small' | 'medium' | 'big'; type?: 'chip' | 'noLine' }) => {
  const styles = useStyles(color, size)
  if (type == 'chip') {
    return (
      <Chip
        label={msg}
        sx={styles.chip({ fit: !!fit })}
      />
    )
  }

  return (
    <Box sx={styles.containerStatus} className="custom-status">
      <Box sx={styles.status(type == 'noLine' ? true : false)} />
      <Typography sx={styles.statusText}>{msg}</Typography>
    </Box>
  )

}

export default StatusComponent
